import { createAsyncThunk } from '@reduxjs/toolkit'
import { workshopEventApi } from 'src/api/workshopEvent'
import { IEventSeoSchema } from 'src/components/workshopAndEvents/workshopEvent/seoConfigForPage/seoConfigSchema'
import { IQuery } from 'src/interfaces/workshopEvent'

export const getListWorkshopEventAction = createAsyncThunk(
  'workshopEvent/getListWorkshopAction',
  async ({ limit = 10, ...otherParams }: IQuery) => {
    try {
      const res = await workshopEventApi.getListWorkshopEvent({
        limit,
        ...otherParams,
      })
      return res
    } catch (error) {
      throw error
    }
  }
)
export const getEventSeoAction = createAsyncThunk(
  'workshop-event/seo/get',
  async () => {
    try {
      const res = await workshopEventApi.getPageSeo()
      return res
    } catch (error) {
      throw error
    }
  }
)
export const updateEventPageSeoAction = createAsyncThunk(
  'workshop-event/seo/update',
  async (body: IEventSeoSchema) => {
    try {
      const res = await workshopEventApi.updatePageSeo(body)
      return res
    } catch (error) {
      throw error
    }
  }
)
